import './Projects.css';

import React from "react";
import "./../index.css";
import { motion } from "framer-motion";


const boxVariants = {
  hover: {
    scale: 1.06,
    transition: {
      type: "spring",
    },
  },
};

const Projects = () => {
  return (
    <section
      data-aos="fade-up"
      className="Projects-container section"
      name="Projects"
      id="Projects"
    >
      <br></br>
      <h1 className="heading">Projects I have Built</h1>
      <div className="projects-container">
        {/* Project 1 - Corona Tracker */}
        <motion.div
          className="projects"
          variants={boxVariants}
          whileHover="hover"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://covid19byusama.surge.sh"
          >
            <div className="project-images" id="coronaTracker"></div>
          </a>

          <div className="project-links">
            <div className="text">
              <h3>Covid 19 Web App</h3>
            </div>
            <div className="icons">
           
              <a
                rel="noopener noreferrer"
                href="http://covid19byusama.surge.sh"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="live preview"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}

        {/* Project 2 - Shoe Store */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://shopcornerofficial.com/"
          >
            <div className="project-images" id="sco"></div>
          </a>

          <div className="project-links">
            <div className="text">
              <h3>Shop Corner Official</h3>
            </div>
            <div className="icons">
             
              <a
                rel="noopener noreferrer"
                href="https://shopcornerofficial.com/"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="live preview"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}

        {/* Project 3 - Quiz App */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://mrmobapp.web.app/"
          >
            <div className="project-images" id="apple"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Mr Mobile</h3>
            </div>
            <div className="icons">
            
              <a
                rel="noopener noreferrer"
                href="https://mrmobapp.web.app/"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="live preview"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}

        {/* Project 4 - Explore matiari */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://chatnetto.web.app/"
          >
            <div className="project-images" id="chat"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Chatnetto Chat App</h3>
            </div>
            <div className="icons">
           
              <a
                rel="noopener noreferrer"
                href="https://chatnetto.web.app/"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="live preview"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}

        {/* Project 5 - Expense Tracker */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://olxreactjs.web.app/"
          >
            <div className="project-images" id="olx"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Olx Clone</h3>
            </div>
            <div className="icons">
         
              <a
                rel="noopener noreferrer"
                href="https://olxreactjs.web.app/"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="live preview"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}

        {/* Project 6 - SpaceX Website */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://trackexpense.surge.sh/"
          >
            <div className="project-images" id="expense"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Expense Tracker</h3>
            </div>
            <div className="icons">
         
              <a
                rel="noopener noreferrer"
                href="http://trackexpense.surge.sh/"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="live preview"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://todopdf.surge.sh/"
          >
            <div className="project-images" id="todo"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Todo App with pdf</h3>
            </div>
            <div className="icons">
         
              <a
                rel="noopener noreferrer"
                href="http://todopdf.surge.sh/"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="live preview"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://babaracservice.web.app/"
          >
            <div className="project-images" id="ac"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Babar AC</h3>
            </div>
            <div className="icons">
         
              <a
                rel="noopener noreferrer"
                href="https://babaracservice.web.app/"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="live preview"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://usamalearner.github.io/js-simple-quizapp/"
          >
            <div className="project-images" id="quiz"></div>
          </a>
          <div className="project-links">
            <div className="text">
              <h3>Simple Quiz App</h3>
            </div>
            <div className="icons">
         
              <a
                rel="noopener noreferrer"
                href="https://usamalearner.github.io/js-simple-quizapp/"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="live preview"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
         



        </motion.div>

       

        {/* // */}
      </div>
      {/* <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://github.com/developer-junaid/"
        className="button-link"
      >
        <button className="button">More Projects</button>
      </a> */}
      <br>
      </br>
      <br/>
      <br/>
      <br></br>
    </section>
  );
};

export default Projects;
